import type { Content } from '../../models';

import { cloneObject } from '../../utilities';
import { VisualsWithDataTypes } from '../../config/constants';
import { getExtendedFormatObject } from '../style';
import { getRightLegendFieldName } from '../../config/dimension.config';
import { getQuillFromFields } from '../base-objects';

export const validateContentVersion69 = (content: Content): boolean => {
  const { type, typeSpecific } = content;

  if (typeSpecific.version < 69) {
    if (VisualsWithDataTypes.includes(type) && typeSpecific.chart) {
      if (typeSpecific.dimensions && typeSpecific.fields) {
        const defaultQuillStyle = getExtendedFormatObject();
        const legendFieldName = getRightLegendFieldName(content.type, typeSpecific.dimensions);

        let legendQuill = JSON.stringify({ ops: [{ insert: '\n' }] });
        if (legendFieldName) {
          const legendField = typeSpecific.fields[legendFieldName];
          legendQuill = getQuillFromFields([legendField]);
        }

        typeSpecific.chart.legend.customQuills = typeSpecific.chart.legend.customQuills ?? [];
        typeSpecific.chart.legend.quillValue = typeSpecific.chart.legend.quillValue ?? legendQuill;
        typeSpecific.chart.legend.quillBackground = typeSpecific.chart.legend.quillBackground ?? { backgroundColor: '#fff' };
        typeSpecific.chart.legend.quillStyle = typeSpecific.chart.legend.quillStyle ?? cloneObject(defaultQuillStyle);
      }

      typeSpecific.chart.axis.labelAxis.gridLines = typeSpecific.chart.axis.labelAxis.gridLines ?? {
        enabled: true,
        stroke: '#ddd',
        strokeWidth: 1,
        strokeDasharray: 'dashed',
      };
    }

    typeSpecific.version = 69; // nice
  }

  return true;
};
